import { Select } from "@material-ui/core";

function CustomSelector({ value, setValue, apiArray, label, width }) {
	return (
		<div style={{ display: "flex", alignItems: "center" }}>
			{label && (
				<label style={{ marginRight: 8, fontWeight: 500 }}>
					{label}
				</label>
			)}
			<Select
				native
				value={value}
				onChange={(e) => setValue(e.target.value)}
				style={{
					width: width || "150px",
					height: "40px",
					textAlign: "center",
					textAlignLast: "center",
					borderRadius: 8,
					background: "#f8fafd",
					transition: "border-color 0.2s, box-shadow 0.2s",
					boxShadow: "0 1px 4px rgba(25, 118, 210, 0.08)",
					outline: "none",
					fontSize: 15,
				}}
			>
				{apiArray.map((code) => (
					<option
						key={code}
						value={code}
						style={
							code === value
								? {
										background: "#e3f2fd",
										color: "#1976d2",
										fontWeight: 700,
								  }
								: {
										background: "#fff",
										color: "#222",
								  }
						}
					>
						{code}
					</option>
				))}
			</Select>
		</div>
	);
}

export default CustomSelector;
